import React from "react";
import {
  FacebookOutlined,
  LinkedinOutlined,
  XOutlined,
  YoutubeOutlined,
  InstagramOutlined,
} from "@ant-design/icons";

function Footer() {
  const socialLinks = [
    {
      icon: <LinkedinOutlined style={{ fontSize: 20, color: "#29367E" }} />,
      url: "https://www.linkedin.com/company/shree-maruti-integrated-logistics-limited/",
    },
    {
      icon: <FacebookOutlined style={{ fontSize: 20, color: "#29367E" }} />,
      url: "https://www.facebook.com/@shreemarutiintegratedlogistics",
    },
    {
      icon: <InstagramOutlined style={{ fontSize: 20, color: "#29367E" }} />,
      url: "https://www.instagram.com/shreemarutiintegratedlogistics/", // call directly
    },
    {
      icon: <XOutlined style={{ fontSize: 20, color: "#29367E" }} />,
      url: "https://x.com/SMILIndia/",
    },
    {
      icon: <YoutubeOutlined style={{ fontSize: 20, color: "#29367E" }} />,
      url: "https://www.youtube.com/@SMILEIndia23",
    },
  ];

  return (
    <div
      style={{
        height: "60px",
        backgroundColor: "#F9F9F9",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        padding: "0 20px",
      }}
    >
      <h5 style={{ margin: 0 }}>
        © Powered by Shree Maruti Integrated Logistics Pvt. Ltd.
      </h5>
      <div style={{ display: "flex", gap: "15px" }}>
        {socialLinks.map((item, index) => (
          <a
            key={index}
            href={item.url}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            {item.icon}
          </a>
        ))}
      </div>
    </div>
  );
}

export default Footer;
